import {
    AnimationClip,
    AnimationMixer,
    Color,
    DoubleSide,
    Euler,
    LoopOnce,
    Mesh,
    MeshBasicMaterial,
    MeshStandardMaterial,
    Object3D,
    PlaneGeometry,
    Quaternion,
    Vector2,
    Vector3
} from 'three'
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry"
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader'
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader"
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
// import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module"
import * as SkeletonUtils from "three/examples/jsm/utils/SkeletonUtils"


 import {
    Body,
    Sphere,
    Cylinder,
 } from 'cannon-es'

import { gsap } from "gsap"

//

import {
    lerp,
    crossfadeAction,
    degToRad,
    randomNum,
    toTitleCase
} from '../components/alpha'

import * as mat from "../components/materials"
import { CharacterController } from './characterController'

import { defPath, fetchPath } from '../config/defPath'


// ------------------------------------------------------------

export class Avatar {

    #_loader = new GLTFLoader()
    #_draco = new DRACOLoader()

    #_entities = { } // All 'gltf' file: scene, animations

    #_initialPos = {x: 0, y: 0, z: 0}
    #_activeCharacter = {
        model: undefined,
        actions: {},
        mixer: undefined,
        body: undefined,
    }

    #_characterController

    
    // Avatares usuarios
    #_names = {
        font: undefined,
        nameMat: new MeshBasicMaterial({ color: 0xffffff }),
        planeMat: new MeshBasicMaterial({ color: new Color(0x003DA6).convertSRGBToLinear(), side: DoubleSide }),
        meshes: []
    }
    #_mixers = { }
    #_usersAvatarsDone = false


    // Estilo
    #_materials = {}
    #_json_basic = {       
        genero: 'Hombre',
        piel: 'B',
        cabello: {type: '03', color: '002D6E' },
        barba: {type: '02', color: '000000' },
        Sup: {type: 'camiseta', code: '01'},
        Inf: {type: 'pant-corta', code: '01'},
        medias: {code: '01'},
        Cal: {type: 'guayos', code: '01'},
        Acc: [
            {type: 'guantes', code: '01'},
            // {type: 'sombrero-01', code: '01'},
            {type: 'gafas-01'}
        ],
    }
    #_json_avatar = undefined
    #_json_temp = undefined
    
    //

    #_usersPos = [
        {x: -15, z: 100, w: degToRad(135) },
        {x: -55, z: 30, w: degToRad(120) },
        {x: 35, z: -110, w: degToRad(0) },
        {x: 5, z: 40, w: degToRad(180) },
        {x: -120, z: 0, w: degToRad(90) },
        {x: 120, z: 5, w: degToRad(250) },
        {x: 90, z: 15, w: degToRad(90) },
        {x: 25, z: -110, w: degToRad(0) },
    ]
    #_usersData

    constructor(params) {
        // this.#_params = params
        new FontLoader().load(`${defPath}/assets/fonts/Abolition.json`, (f) => this.#_names.font = f)

        if (typeof(Storage) !== 'undefined') {
            if (typeof(sessionStorage.avatars) == 'undefined') {
                console.log('entra al fetch')
                this.#_usersData = fetch(`${fetchPath}/aguila/loyalty/avatars?amount=${this.#_usersPos.length}`, { method: 'POST' })
            }
        }  
    }

    //

    get active() {
        return this.#_activeCharacter
    }

    get jsonAvatar() {
        return this.#_json_avatar
    }
    get jsonTemp() {
        return this.#_json_temp
    }

    get materials() {
        return this.#_materials
    }

    //

    setJSON(json) {
        this.#_json_avatar = JSON.parse(JSON.stringify(json))
        this.#_json_temp = JSON.parse(JSON.stringify(this.#_json_avatar))
    }

    loadModel(name) {
        const loadControl = window.loadControl

        this.#_draco.setDecoderPath(`${defPath}/assets/glb/draco/`)
        this.#_draco.setDecoderConfig({ type: 'js' })

        this.#_entities[name] = new Promise( resolve => {
            this.#_loader
            .setDRACOLoader(this.#_draco)
            .load( `${defPath}/assets/glb/${name}.glb`,
                (gltf) => {
                    resolve(gltf)
                },
                (xhr) => {
                    loadControl.elements['glb_' + name] = { loaded: xhr.loaded, total: xhr.total }
                    if (loadControl.allowLogSize && xhr.loaded === xhr.total) console.log(`GLB "${name}" - ${(xhr.total / 1024 / 1024).toFixed(2)}Mb`)
                },
                (error) => {
                    console.warn(`[A] ${name}: Error loading`)
                    // console.warn( error )
                }
            )
        })
    }

    async initModel({gender, destiny}) {

        // Check session and define JSON
        const session = this.#_json_avatar === undefined ? false : true
        let json = session ? this.#_json_avatar : this.#_json_basic

        //

        let genero
        let cleanUp

        let generoRandom = ['Hombre', 'Mujer'][Math.floor(Math.random() * 2)]

        if(destiny == 'Estadio') {
            if(!gender) {
                genero = this.#_json_avatar.genero
            } else {
                genero = gender
                json.genero = gender
            }

            cleanUp = true
        }

        if(destiny == 'Alone') {
            if (!session) {
                genero = gender ? gender : generoRandom
                json.genero = genero
            } else {
                genero = this.#_json_avatar.genero
            }

            cleanUp = true
        }

        if(destiny == 'Camerino') {
            genero = this.#_json_avatar.genero

            if(gender) {
                json = this.#_json_avatar.genero == gender ? this.#_json_avatar : this.#_json_basic
                genero = json.genero = gender

                this.#_json_temp = JSON.parse(JSON.stringify(json))
                // this.#_json_temp = JSON.parse(JSON.stringify(this.#_json_avatar)) 
            }

            cleanUp = false
        }

        //

        const gltf = await this.#_entities[genero]

        // Three
        const model = this.#_activeCharacter.model = SkeletonUtils.clone(gltf.scene)
        model.position.copy( this.#_initialPos )
        model.rotation.y = Math.PI

        model.castShadow = true
        model.traverse( obj => obj.castShadow = true )

        await this.readJSON(model, json, cleanUp)

        const mixer = this.#_activeCharacter.mixer = new AnimationMixer(model)
        const clips = gltf.animations
        clips.forEach( clip => {
            this.#_activeCharacter.actions[ clip.name ] = mixer.clipAction( clip )
        })

        window.scene.add(model)

        //

        // Cannon
        if(window.world) {
            const body = this.#_activeCharacter.body = new Body({
                mass: 0.5,
                shape: new Sphere(1), // new Box( new Vec3(1.5,1,1.5) ), // 
            })
            body.position.set(this.#_initialPos.x, 2, this.#_initialPos.z)
            body.linearDamping = 0.85
            body.angularDamping = 0.85

            // body.collisionResponse = true
            // body.sweptSphereRadius = 0.1

            window.world.addBody(body)
        }

        // ------

        if(destiny == 'Estadio') {
            this.#_characterController = new CharacterController({
                avatar: this.#_activeCharacter, // Model, body, mixer & actions
                camera: window.cameraController.camera
            })

            window.cameraController.target = this.#_activeCharacter.model
        } 

        if(destiny == 'Camerino' || destiny == 'Alone') {

            // Inicializar animaciones
            const toRemove = ['Caminar', 'Trotar', 'Correr', 'Burpee', 'Abdominales']
            let animations = Object.keys(this.#_activeCharacter.actions).filter( animName => !toRemove.includes( animName ) )
            animations.forEach( animName => {
                const action = this.#_activeCharacter.actions[animName]
                action.name = animName
                action.loop = LoopOnce
                action.clampWhenFinished = true
            })

            this.#_activeCharacter.actions['Saltar'].play()

            const handleAnimationFinished = async (e) => {
                const current = this.#_activeCharacter.actions[e.action.name]
                let next = this.#_activeCharacter.actions[ animations[Math.floor(Math.random() * animations.length)] ]

                if( current == next ) next = this.#_activeCharacter.actions[ animations[Math.floor(Math.random() * animations.length)] ]
                if( current == next ) next = this.#_activeCharacter.actions[ animations[Math.floor(Math.random() * animations.length)] ]

                crossfadeAction(current, next, 0.65)
            }

            mixer.addEventListener('finished', handleAnimationFinished)
        }
    }
    removeModel() {
        return new Promise (resolve => {

            window.scene.remove(this.#_activeCharacter.model)
            this.#_activeCharacter.model = undefined

            setTimeout(() => {

                if(this.#_activeCharacter.body) {
                    window.world.removeBody(this.#_activeCharacter.body)
                    this.#_activeCharacter.body = undefined
                }

                // Reset active data
                this.#_activeCharacter = {
                    model: undefined,
                    actions: {},
                    mixer: undefined,
                    body: undefined,
                }

                resolve('Done')
            }, 10)

        })
    }

    //

    createUsersAvatars() {

        const tempPos = JSON.parse(JSON.stringify(this.#_usersPos))

        const selectRandomElems = (arr, num) => {
            let result = []
            for (let i = 0; i < num; i++) {
              let randomIndex = Math.floor(Math.random() * arr.length)
              result.push(arr[randomIndex])
              arr.splice(randomIndex, 1)
            }
            return result
        }

        return new Promise( async resolve => { 

            // Fetchs and format
            if (typeof(Storage) !== 'undefined') {
                if (typeof(sessionStorage.avatars) == 'undefined') {
                    await this.#_usersData
                        .then( res => res.json() )
                        .then( r => {
                            console.log(r);
                            sessionStorage.setItem('avatars',  JSON.stringify(r.data))
                        })                    
                }
            } 

            const response = JSON.parse(sessionStorage.avatars)
            for (let i = 0; i < response.length; i++) { 
                response[i].style = JSON.parse(response[i].style) 
            }

            const usersAvatares = response

            const createName = (userName) => {

                const container = new Object3D()

                const geo = new TextGeometry(userName, {
                    font: this.#_names.font,
                    size: 1,
                    height: 0,
                    curveSegments: 3
                })
                geo.computeBoundingBox()
                let xMid = - 0.5 * ( geo.boundingBox.max.x - geo.boundingBox.min.x )
                let yMid = - 0.5 * ( geo.boundingBox.max.y - geo.boundingBox.min.y )
                geo.translate( xMid, yMid, 0 )

                const nameMesh = new Mesh(geo, this.#_names.nameMat)
                container.add(nameMesh)

                let nameSize = new Vector3()
                geo.boundingBox.getSize( nameSize )
                const plane = new Mesh(
                    new PlaneGeometry( nameSize.x + 1, nameSize.y + 0.5 ),
                    this.#_names.planeMat
                )
                plane.position.z = -0.25
                container.add( plane )

                const detail = new Mesh(
                    new PlaneGeometry(1, 1),
                    this.#_names.planeMat
                )
                detail.position.set(0, yMid, -0.26)
                detail.rotation.z = Math.PI / 4
                container.add( detail )

                container.position.y = 11.5

                this.#_names.meshes.push( container )

                return container
            }

            for (let i = 0; i < usersAvatares.length; i++) {
                const user = usersAvatares[i]
                const {name} = user
                const pos = {x: tempPos[i].x, y: 0, z: tempPos[i].z }
                const rotY = tempPos[i].w

                let json = user.style
                if(!json) json = Object.assign({}, this.#_json_basic)

            // Three -----------------
                const gltf = await this.#_entities[ toTitleCase(json.genero) ]

                const model = SkeletonUtils.clone(gltf.scene)
                model.position.copy(pos)
                model.rotateY(rotY)

                model.castShadow = true
                model.traverse( obj => obj.castShadow = true )

                await this.readJSON(model, json)

                model.add( createName(name) )

                window.scene.add(model)

                //

                const mixer = new AnimationMixer(model)
                this.#_mixers[`${name}_${randomNum(0,100)}`] = mixer

                const n = 3 // Cantidad de clips
                const toRemove = ['Caminar', 'Trotar', 'Correr', 'Burpee']
                const actions = {}

                let clips = gltf.animations.filter( anim => !toRemove.includes( anim.name ) )
                clips = selectRandomElems(clips, n)
                clips.forEach( clip => {
                    const action = mixer.clipAction( clip )
                    action.name = clip.name
                    action.loop = LoopOnce
                    action.clampWhenFinished = true
                    actions[clip.name] = action
                })

                actions[ clips[0].name ].play()

                let counter = n // Repetitions counter
                mixer.addEventListener('finished', (e) => {
                    ++counter

                    const current = actions[e.action.name]
                    const next = actions[ clips[counter % n].name ]
                        // console.log(name, counter % n, clips[counter % n].name)
                    crossfadeAction(current, next, 0.75)
                })

                
            // Cannon -----------------
                const body = new Body({
                    mass: 0,
                    shape: new Cylinder(3.5,2.5,4,12),
                })
                body.position.set(pos.x, 2.5, pos.z)
                body.quaternion.copy(model.quaternion)
                window.world.addBody(body)
            }

            this.#_usersAvatarsDone = true
            resolve('Ready Avatares')

        })
    }

    // ------------
    

    /*
    - estilo
        + genero              -----
        + piel              'Est_piel-H_A.png' // ----- A B C D E
        + cabellos > color  'Est-H_cabello-01.png'
        + barbas > color    'Est_barba-xx.png'
    - up
        + camisetas         'Sup_camiseta_xx.png'
        + hoodies           'Sup_hoodie_xx.png'
        + chaquetas         'Sup_chaqueta_xx.png'
    - down
        + pantalonetas      'Inf_pant-corta_xx.png' / 'Inf_pant-larga_xx.png'
        + jean  
                    'Inf_jean_xx.png'
        + pesquero          'Inf_pesquero_xx.png'
        + hopper            'Inf_hopper_xx.png'
        (jogger)
    - calzado // 04
        + guayos            'Cal_guayo_xx.png'
        + tenis             'Cal_tenis_xx.png'
        + botines           'Cal_botin_xx.png'
        + medias            'Cal_medias_xx.png'
        (zapatillas)
    - accesorios
        + sombreros         'Acc_sombrero-xx_xx.png'
        + gafas             'Acc_gafa-xx.png'
        + guantes           'Acc_guante_xx.png'
    - canjeables()
                            'Inf_jean_xxx_p-150.png'
                            'Cal_guayo_xxx_p-250.png'
    */

    readJSON(model, json, cleanUp) {
        //
        return new Promise( resolve => {

            // Mats ------
            this.#_materials.skinMat = new MeshStandardMaterial({
                map: mat.imagesLoader(`avatares/Est_piel-${json.genero.charAt(0).toUpperCase()}_${json.piel}.jpg`),
                roughness: 0.65,
                envMapIntensity: 0.75,
            })
            const hairType = json.cabello.type === '00' ? '01' : json.cabello.type
            this.#_materials.hairMat = new MeshStandardMaterial({
                map: mat.imagesLoader(`avatares/Est-${json.genero.charAt(0).toUpperCase()}_cabello-${hairType}.png`),
                color: new Color(`#${json.cabello.color}`),
                roughness: 0.9,
                metalness: 0.4,
                // transparent: true,
                alphaTest: 0.75,
                side: DoubleSide,
            })

            if( json.Sup.type === 'camiseta' ) {
                const a = ['04', '05', '06', '07', '08', '09']
                if( a.includes(json.Sup.code) ) json.Sup.code = '01'
            }
            this.#_materials.supMat = new MeshStandardMaterial({
                map: mat.imagesLoader(`avatares/Sup_${json.Sup.type}_${json.Sup.code}.png`),
                roughness: 0.75,
                metalness: 0.1,
                side: DoubleSide,
            })
            this.#_materials.infMat = new MeshStandardMaterial({
                map: mat.imagesLoader(`avatares/Inf_${json.Inf.type}_${json.Inf.code}.png`),
                roughness: 0.75,
                metalness: 0.1,
            })
            this.#_materials.calMat = new MeshStandardMaterial({
                map: mat.imagesLoader(`avatares/Cal_${json.Cal.type}_${json.Cal.code}.png`),
                roughness: 0.65,
                metalness: 0.35,
            })
            const socksType = json.medias.code === '00' ? json.piel : json.medias.code
            this.#_materials.socksMat = new MeshStandardMaterial({
                map: mat.imagesLoader(`avatares/Cal_medias_${socksType}.png`),
                roughness: 0.75,
                metalness: 0.15,
            })

        // ------------------

            // Hide all
            model.children.forEach( obj => {
                if(obj.name == 'Armature') return
                obj.frustumCulled = false
                obj.visible = false

                // console.log(obj.name)
            })

            // Stylize!
            for (let i = 0; i < model.children.length; i++) {
                const mesh = model.children[i]

                if(mesh.name.includes('cuerpo_')) {
                    if(mesh.name == 'cuerpo_cabeza') mesh.visible = true
                    if(mesh.name == 'cuerpo_manos') mesh.visible = true
                    mesh.material = this.#_materials.skinMat

                    if(mesh.name == 'cuerpo_pantorrillas' || mesh.name == 'cuerpo_tobillos') {
                        mesh.material = this.#_materials.socksMat
                    }

                    // Sup
                    if(json.Sup.type == 'camiseta' && mesh.name == 'cuerpo_brazos') mesh.visible = true
                    
                    // Inf
                    if (mesh.name == 'cuerpo_tobillos') mesh.visible = true
                    if (json.Inf.type.includes('pant-') && mesh.name == 'cuerpo_pantorrillas') mesh.visible = true
                    if (json.Inf.type == 'pant-corta' && mesh.name == 'cuerpo_rodillas') mesh.visible = true
                }

                if( mesh.name.includes(`cabello-${json.cabello.type}`) ) {
                    mesh.material = this.#_materials.hairMat
                    mesh.visible = true
                }

                if(json.genero == 'Hombre') {
                    if( mesh.name == `barba-${json.barba.type}`) {
                        mesh.visible = true
                        mesh.material.color = new Color(`#${json.barba.color}`)

                        this.#_materials.beardMat = mesh.material
                    }
                }

                if( mesh.name == `Sup_${json.Sup.type}` ) {
                    mesh.material = this.#_materials.supMat
                    mesh.visible = true
                }

                if( mesh.name == `Inf_${json.Inf.type}`) {
                    mesh.material = this.#_materials.infMat
                    mesh.visible = true
                }

                if( mesh.name == `Cal_${json.Cal.type}`) {
                    mesh.material = this.#_materials.calMat
                    mesh.visible = true
                }
            }
            
            json.Acc.forEach( Acc => {

                const mesh = model.getObjectByName(`Acc_${Acc.type}`)
                mesh.visible = true
                
                if(Acc.type == 'guantes') model.getObjectByName('cuerpo_manos').visible = false
                if(Acc.type.includes('gafas-')) return

                mesh.material = new MeshStandardMaterial({
                    map: mat.imagesLoader(`avatares/Acc_${Acc.type}_${Acc.code}.png`),
                    roughness: 0.75,
                    metalness: 0.15,
                })

                this.#_materials[Acc.type] = mesh.material
            })
            
            //* Canjeables?

            //

            // Model clean-up
            if(cleanUp) {
                const toRemove = []
                model.traverse( (obj) => {
                    if(obj.visible == false) toRemove.push(obj.id)
                })
                toRemove.forEach( id => {
                    const e = model.getObjectById(id)
                    e.removeFromParent()
                })
            }

            //

            resolve('Done')
        })
    }

    async changeGender(e) {

        const gender = e.target.getAttribute('data-v')
        const json = window.avatar.jsonTemp

        // If is the current active, return
        if (json.genero == gender) return

        await window.avatar.removeModel()
        window.avatar.initModel({gender, destiny: 'Camerino'})

        // Update json
        json.genero = gender
    }
    async changeSkin(e) {

        const target = e.target.getAttribute('data-v')
        const json = window.avatar.jsonTemp
        const model = window.avatar.active.model

        // If is the current active, return
        if (json.piel == target) return

        // Update texture
        const newTexture = await mat.imagesLoaderPromise(`avatares/Est_piel-${json.genero.charAt(0).toUpperCase()}_${target}.jpg`)
        model.getObjectByName('cuerpo_cabeza').material.map = newTexture 

        // Check socks - Find and update material
        if(json.medias.code == '00') {
            const material = window.avatar.materials['socksMat']
            material.map = mat.imagesLoader(`avatares/Cal_medias_${target}.png`)
        }

        // Update json
        json.piel = target
    }
    async changeHair(e) {

        const target = e.target.getAttribute('data-v')
        const json = window.avatar.jsonTemp
        const model = window.avatar.active.model

        // If is the current active, return
        if (json.cabello.type == target) return

        // Find and update material
        const material = window.avatar.materials.hairMat
        const newTexture = target !== '00' ? await mat.imagesLoaderPromise(`avatares/Est-${json.genero.charAt(0).toUpperCase()}_cabello-${target}.png`) : undefined
        material.map = newTexture

        for (let i = 0; i < model.children.length; i++) {
            const mesh = model.children[i]

            if (mesh.name.includes(`cabello-`)) mesh.visible = false

            if (mesh.name == (`cabello-${target}`)) {
                mesh.material = material
                mesh.visible = true
            }
        }

        // Update json
        json.cabello.type = target
    }
    async changeBeard(e) {

        const target = e.target.getAttribute('data-v')
        const json = window.avatar.jsonTemp
        const model = window.avatar.active.model

        // If is the current active, return
        if (json.genero == 'Mujer') return
        if (json.barba.type == target) return

        for (let i = 0; i < model.children.length; i++) {
            const mesh = model.children[i]

            if (mesh.name.includes(`barba-`)) mesh.visible = false
            if (mesh.name == `barba-${target}`) mesh.visible = true
        }

        // Update json
        json.barba.type = target
    }
    async changeColor(e) {

        const [target, color] = e.split('_') //target.getAttribute('data-v').split('_')
        const json = window.avatar.jsonTemp

        const materials = window.avatar.materials
        const material = target == 'cabello' ? materials.hairMat : materials.beardMat

        // Darker if is beard
        const defColor = target == 'barba' ? new Color(`#${color}`).lerp(new Color("#000"), .65) : new Color(`#${color}`)

        material.color = defColor

        // Actualizar JSON
        json[target].color = color
    }
    async changeItem(e) {

        const string = e.target.getAttribute('data-v')
        const target = string.split('_')
        const json = window.avatar.jsonTemp
        const model = window.avatar.active.model

        // If is the current active, return
        if ( json[`${target[0]}`].type == target[1] && json[`${target[0]}`].code == target[2]) return

        // Reset another items if is Canjeable
        // if ( e.target.classList.contains('canjeable_')) console.log('Canj')// await this.resetAvatarStyle()

        // Find and update material
        const material = window.avatar.materials[`${target[0].toLowerCase()}Mat`]
        const newTexture = await mat.imagesLoaderPromise(`avatares/${string}.png`)
        material.map = newTexture

        // Handle meshes
        for (let i = 0; i < model.children.length; i++) {
            const mesh = model.children[i]

            if (mesh.name.includes(`${target[0]}_`)) {
                mesh.visible = false
            }
            if (mesh.name == `${target[0]}_${target[1]}`) {
                mesh.material = material
                mesh.visible = true
                console.log('Found')
            }

            //

        // Especial body cases ------------------------
            // Sup ------
            if(target[1] == 'hoodie' || target[1] == 'chaqueta') {
                if (mesh.name == 'cuerpo_brazos') mesh.visible = false
            }
            if(target[1] == 'camiseta') {
                if (mesh.name == 'cuerpo_brazos') mesh.visible = true
            }
            // Inf ------
            if(target[1].includes('pant-')) {
                if (mesh.name == 'cuerpo_rodillas') mesh.visible = false
                if (mesh.name == 'cuerpo_pantorrillas' || mesh.name == 'cuerpo_tobillos') mesh.visible = true

                if(target[1] == 'pant-corta' && mesh.name == 'cuerpo_rodillas') mesh.visible = true
            }
            if(target[1].includes('jean') || target[1] == 'hopper' || target[1] == 'pesquero') {
                if (mesh.name == 'cuerpo_rodillas' || mesh.name == 'cuerpo_pantorrillas') mesh.visible = false
                if (mesh.name == 'cuerpo_tobillos') mesh.visible = true
            }
        }

        // Actualizar JSON
        json[`${target[0]}`].type = target[1]
        json[`${target[0]}`].code = target[2]
    }
    async changeSocks(e) {
        
        const string = e.target.getAttribute('data-v')
        const target = string.split('_')[2]
        const json = window.avatar.jsonTemp

        // If is the current active, return
        if (json.medias.code == target) return

        // Find and update material
        const material = window.avatar.materials['socksMat']
        let textName = target == '00' ? `Cal_medias_${json.piel}` : `Cal_medias_${target}`
        const newTexture = await mat.imagesLoaderPromise(`avatares/${textName}.png`)
        material.map = newTexture

        // Update json
        json.medias.code = target
    }
    async changeAcc(e) {

        //* Se puede mejorar

        const string = e.target.getAttribute('data-v')
        const target = string.split('_')
        const json = window.avatar.jsonTemp
        const model = window.avatar.active.model

        // If is the current active, return
        let abort = false
        json.Acc.forEach( obj => {
            if(obj.type.includes( target[1] ) && obj.code == target[2]) abort = true
        })
        if (abort) return


        if (!target[1].includes('gafas')) {

            // Hide
            for (let i = 0; i < model.children.length; i++) {
                const mesh = model.children[i]
                if (mesh.name.includes(`${target[1]}`)) mesh.visible = false
            }

            if(target[2] !== '00') {

                let material = window.avatar.materials[`${target[1]}`]
                if(!material) {
                    material = window.avatar.materials[`${target[1]}`] = new MeshStandardMaterial({
                        roughness: 0.75,
                        metalness: 0.15,
                    })
                }
                // material.map = mat.imagesLoader(`avatares/${string}.png`)
                const newTexture = await mat.imagesLoaderPromise(`avatares/${string}.png`)
                material.map = newTexture

                // Show
                for (let i = 0; i < model.children.length; i++) {
                    const mesh = model.children[i]
                    if (mesh.name == `Acc_${target[1]}`) {
                        mesh.material = material
                        mesh.visible = true
                    }
                }
    
            } else {
                const d = json.Acc.find( a => a.type.includes(target[1]))
                const index = json.Acc.indexOf(d)
                if( index > -1) json.Acc.splice(index, 1)
            }

            // Body cases
            if(target[1] == 'guantes') model.getObjectByName(`cuerpo_manos`).visible = true

            // Update json
            if(target[2] !== '00') {
                const n = {type: target[1], code: target[2]}

                // Existe en array?
                const obj = json.Acc.find( a => a.type.includes(target[1]))

                if(obj) {
                    obj.code = target[2]
                } else {
                    json.Acc.push(n)
                }
            }


        } else {

            // Hide
            for (let i = 0; i < model.children.length; i++) {
                const mesh = model.children[i]

                const newString = target[1].substring(0, target[1].length - 3)
                if (mesh.name.includes(`${newString}`)) mesh.visible = false
            }

            if(target[2] !== '00') {
                // Show
                for (let i = 0; i < model.children.length; i++) {
                    const mesh = model.children[i]
                    if (mesh.name == `Acc_${target[1]}`) mesh.visible = true
                }
    
            } else {
                const d = json.Acc.find( a => a.type.includes(target[1]))
                const index = json.Acc.indexOf(d)
                if( index > -1) json.Acc.splice(index, 1)
            }


            // Update json
            if(target[2] !== '00') {
                const n = {type: target[1]}

                // Existe en array?
                const newString = target[1].substring(0, target[1].length - 3)
                // if (mesh.name.includes(`${newString}`)) mesh.visible = false
                const obj = json.Acc.find( a => a.type.includes(newString))

                if(obj) {
                    obj.type = target[1]
                } else {
                    json.Acc.push(n)
                }
            }
        }

    }

    async resetAvatarStyle() {
        // Cuando cambia un articulo pero no lo compra, al volver a las categorias

        // Reset activeCharacter if 'Genero' is dismatch
        if (this.#_json_temp.genero !== this.#_json_avatar.genero ) {
            await this.removeModel()
            await this.initModel({genero: this.#_json_avatar.genero, destiny: 'Camerino'})
        }

        // Reset
        this.#_json_temp = JSON.parse(JSON.stringify(this.#_json_avatar))

        // Read again
        if (this.#_json_temp.genero == this.#_json_avatar.genero ) {
            await this.readJSON(this.#_activeCharacter.model, this.#_json_temp, false)
        }
    }
    purchasedItem() {
        // Volver a crear el 'this.#_json_avatar' y 'this.#_json_temp'
        this.setJSON(this.#_json_temp)
    }

    saveJson(e) {
        const json = window.avatar.jsonTemp
        // console.log(json)
    }

    initEditor() {

        const addListeners = (type, f) => {
            document.querySelectorAll(`[data-t='${type}']`).forEach( btn => {
                btn.addEventListener('pointerup', f, true)
            })
        }

        addListeners('gender', this.changeGender)
        addListeners('skin', this.changeSkin)
        addListeners('hair', this.changeHair)
        addListeners('beard', this.changeBeard)
        // addListeners('color', this.changeColor)
        addListeners('item', this.changeItem)
        addListeners('socks', this.changeSocks)
        addListeners('acc', this.changeAcc)

        addListeners('saveJson', this.saveJson)
    }

    // ------------

    toggleControls(value) {
        if(this.#_characterController) {
            this.#_characterController.enabled = value
        }
        window.cameraController.enableFollow = value
    }

    // ------------

    update(delta) {

        if(this.#_activeCharacter.mixer) this.#_activeCharacter.mixer.update(delta)

        if(this.#_usersAvatarsDone) {
            Object.values(this.#_mixers).forEach( m => m.update(delta) )
            this.#_names.meshes.forEach( n => n.lookAt( window.cameraController.camera.position ))
        }

        if (this.#_characterController) this.#_characterController.update(delta)

    }
}